import {
  GET_EDUCATION_RECOMMEND_BANNER,
  GET_EDUCATION_RECOMMEND_GROUPS,
  GET_EDUCATION_CATEGORY_TAGS,
  GET_EDUCATION_CATEGORY_GRADELIST,
  SET_EDUCATION_CATEGORY_ERROR,
  GET_EDUCATION_MINE_GRADELIST,
  SET_EDUCATION_MINE_ERROR,
  SET_EDUCATION_MINE_LOADING,
  DELETE_EDUCATION_MINE_GRADELIST,
  GET_EDUCATION_DETAIL,
  GET_EDUCATION_PLAY_URL,
  GET_EDUCATION_PLAY_DATA_REPORT,
  GET_EDUCATION_COLLECT_REPORT,
  SET_EDUCATION_RECOMMEND_LOADING,
  GET_EDUCATION_PAY_CREATE,
  SET_EDUCATION_PAY_CREATE,
  GET_EDUCATION_PAY_RESULT,
  SET_EDUCATION_PAY_RESULT,
} from '../constants/education';

export const getEducationRecommendBanner = payload => ({
  type: GET_EDUCATION_RECOMMEND_BANNER,
  payload,
});
export const getEducationRecommendGroups = payload => ({
  type: GET_EDUCATION_RECOMMEND_GROUPS,
  payload,
});
export const setEducationRecommendLoading = payload => ({
  type: SET_EDUCATION_RECOMMEND_LOADING,
  payload,
});
export const getEducationCategoryTags = payload => ({
  type: GET_EDUCATION_CATEGORY_TAGS,
  payload,
});
export const getEducationCategoryGradelist = payload => ({
  type: GET_EDUCATION_CATEGORY_GRADELIST,
  payload,
});
export const setEducationCategoryError = payload => ({
  type: SET_EDUCATION_CATEGORY_ERROR,
  payload,
});
export const getEducationMineGradelist = payload => ({
  type: GET_EDUCATION_MINE_GRADELIST,
  payload,
});
export const setEducationMineError = payload => ({
  type: SET_EDUCATION_MINE_ERROR,
  payload,
});

export const setEducationMineLoading = payload => ({
  type: SET_EDUCATION_MINE_LOADING,
  payload,
});

export const deleteEducationMineGradeList = payload => ({
  type: DELETE_EDUCATION_MINE_GRADELIST,
  payload,
});

export const getEducationDetail = payload => ({
  type: GET_EDUCATION_DETAIL,
  payload,
});

export const getEducationPlayUrl = payload => ({
  type: GET_EDUCATION_PLAY_URL,
  payload,
});

export const postEducationPlayDataReport = payload => ({
  type: GET_EDUCATION_PLAY_DATA_REPORT,
  payload,
});

export const postEducationCollectReport = payload => ({
  type: GET_EDUCATION_COLLECT_REPORT,
  payload,
});

export const postEducationPay = payload => ({
  type: GET_EDUCATION_PAY_CREATE,
  payload,
});

export const setEducationPay = payload => ({
  type: SET_EDUCATION_PAY_CREATE,
  payload,
});

export const setEducationPayResult = payload => ({
  type: SET_EDUCATION_PAY_RESULT,
  payload,
});

export const getEducationPayResult = payload => ({
  type: GET_EDUCATION_PAY_RESULT,
  payload,
});
